import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TopNav from "../components/TopNav";
import "./detail.css";
import { FiArrowLeftCircle } from "react-icons/fi";

const DetailPage = ({ match }) => {
  const [post, setPost] = useState({});

  const fetchPost = async () => {
    const { data } = await axios.get(
      `https://listendonate.herokuapp.com/api/posts/${match.params.id}`
        // `http://localhost:5000/api/posts/${match.params.id}`

    );
    setPost(data);
  };

  useEffect(() => {
    fetchPost();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="detailWrapper">
      <TopNav />

      <div className="detailContainerWrapper">
        <Link to="/" className="back">
          <FiArrowLeftCircle className="icon" /> Back To Homepage
        </Link>
        <div className="detailContainer">
          <img
            className="detailImg"
            // src={`https://listendonate.herokuapp.com/${post.postImage}`}
            src={post.postImage}
            alt={post.postTitle}
          />
          <div className="textWrapper">
            <h1 className="songName">{post.postTitle}</h1>
            {post.createdAt && (
              <span className="date">{`${post.createdAt.substring(
                0,
                10
              )}`}</span>
            )}
            <p className="description">
              {post.postDescription &&
                `${post.postDescription} Link
              ကိုနှိပ်ပြီးနားထောင်ရုံနဲ့လှူဒါန်းနိုင်မှာမလို့ link
              ကိုနှိပ်ပြီးသီချင်းနားထောင်ပေးဖို့တောင်းဆိုပါရစေ
              ဘယ်လိုလှူဒါန်းနိုင်လဲဆိုတဲ့အသေးစိတ်ကိုသိချင်ရင်ဒီမှာဖတ်ကြည့်လို့ရပါတယ်။`}
            </p>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/108228364876629/posts/109085298124269/"
              className="donateBtn"
            >
              Donation Detail
            </a>
            <h2 className="songLinkTitle">Song Links</h2>
            <div className="songBtns">
              {post.postLinks &&
                post.postLinks.map((post) => (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={post.link}
                    className="songBtn"
                  >
                    {post.linkName}
                  </a>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
